import { FormattedMessage } from 'react-intl'

import { Alert } from '@gto/ui/alert'

type MutationErrorProps = {
  show: boolean
  messageId: string
  /**
   * Optional partner-actionable detail string already sanitised by the BE
   * (e.g. a `CustomValidationError.detail`). When set and non-empty, it
   * supersedes `messageId` so the partner sees the actionable reason instead
   * of the generic fallback. Sentry is unaffected — observability stays in
   * `useMutationErrorHandler`'s capture path.
   */
  detail?: string | null
  'data-tst'?: string
}

/**
 * Inline error Alert rendered at a mutation's action site so a failed write
 * operation never fails silently. The app has no SnackbarProvider, so this inline
 * Alert is the user-visible surface instead of a toast. Pair with
 * {@link import('@/hooks/use-mutation-error-handler').useMutationErrorHandler}.
 */
export const MutationError = ({
  show,
  messageId,
  detail,
  'data-tst': dataTst,
}: MutationErrorProps) => {
  if (!show) {
    return null
  }

  return (
    <Alert
      data-tst={dataTst}
      severity="error"
    >
      {detail != null && detail !== '' ? detail : <FormattedMessage id={messageId} />}
    </Alert>
  )
}
